export default [
  {
    key: 'title',
    label: 'field.title',
    type: 'text',
    md: 12,
    lg: 4,
  },
  {
    key: 'isActive',
    label: 'field.status',
    type: 'radio',
    options: [
      { text: 'status.active', value: true },
      { text: 'status.inactive', value: false },
    ],
    md: 12,
    lg: 4,
  },

]
